// Resolve a value that may be a plain value or a getter. Every display field of
// a menu row and of a setting takes this form, so a reactive source — the
// app's language, a store — flows through.
function resolveValue(value) {
    if (typeof value === 'function') {
        return value();
    }
    return value;
}

export { resolveValue };
